<template>
  <v-app>
    <v-navigation-drawer
      :clipped="true"
      temporary
      v-model="drawer"
      app
      style="padding-top: 64px">
      <v-list rounded nav>
        <v-list-item v-if="user" :to="{ name: 'Home' }" exact>
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="title">
              Acasa
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="user" :to="{ name: 'APLs' }" exact>
          <v-list-item-icon>
            <v-icon>mdi-domain</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="title">
              APL-uri
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="user" :to="{ name: 'PropertyGroups' }" exact>
          <v-list-item-icon>
            <v-icon>mdi-map-marker-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="title">
              Property Groups
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="user" :to="{ name: 'Properties' }" exact>
          <v-list-item-icon>
            <v-icon>mdi-map-marker-question</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="title">
              Properties
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="user" :to="{ name: 'Statuses' }" exact>
          <v-list-item-icon>
            <v-icon>mdi-map-marker-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="title">
              Statuses
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="user" :to="{ name: 'Categories' }" exact>
          <v-list-item-icon>
            <v-icon>mdi-map-marker-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="title">
              Categories
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="user" :to="{ name: 'Markers' }" exact>
          <v-list-item-icon>
            <v-icon>mdi-map-marker</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="title">
              Markers
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="user" :to="{ name: 'UserTypes' }" exact>
          <v-list-item-icon>
            <v-icon>mdi-account-convert</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="title">
              Tipuri user
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="user" :to="{ name: 'Users' }" exact>
          <v-list-item-icon>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="title">
              Useri
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      :clipped-left="true"
      style="flex-grow: 0; z-index: 8"
      color="grey lighten-3">
      <v-app-bar-nav-icon @click="drawer = !drawer" v-if="user">
        <slot>
          <!-- <v-img :src="require('./assets/logo-tud.png')" height="48" width="48" contain></v-img> -->
          <v-icon>mdi-menu</v-icon>
        </slot>
      </v-app-bar-nav-icon>
      <img :src="require('./assets/logo-tud.png')" style="height: 48px;" class="mr-4" />

      <template v-if="apl && apl.website && apl.website.show">
        <a :href="apl.website.url" target="_blank">
          <img :src="getURL()" style="height: 48px; vertical-align: middle" />
        </a>
      </template>

      <v-spacer></v-spacer>
      <v-toolbar-title>Sectorul 3 al Municipiului Bucuresti</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="showLogSheet" v-if="user" title="Mesaje">
        <v-icon>mdi-bell</v-icon>
      </v-btn>
      <v-btn icon @click="showLoginForm" v-if="!user" title="Autentificare">
        <v-icon>mdi-login</v-icon>
      </v-btn>
      <v-btn icon @click="logout" v-else title="Iesire din aplicatie">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main>
      <v-dialog
        persistent
        v-model="loginForm"
        width="500">
        <v-card>
          <v-card-title>
            <span>Autentificare</span>
            <v-spacer></v-spacer>
            <v-btn icon small>
              <v-icon small color="error" @click="closeLoginForm">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-form v-model="validForm" ref="form">
              <v-text-field
                v-model="email"
                label="e-mail"
                required
                :rules="required">
              </v-text-field>
              <v-text-field
                :type="showPass ? 'text' : 'password'"
                v-model="password"
                label="parola"
                required
                :rules="required"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPass = !showPass">
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" outlined @click="closeLoginForm">Inchide</v-btn>
            <v-btn color="primary" @click="login">Autenmtifica-te</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <router-view />
      <v-bottom-sheet v-model="showLog" scrollable>
        <v-card>
          <v-card-title>
            <span>Mesaje</span>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="logSearch"
              label="termen cautare"
              hint="cautare dupa text"
              clearable>
            </v-text-field>
            <v-spacer></v-spacer>
            <v-menu
              :open-on-hover="false"
              :close-on-click="true"
              :close-on-content-click="true">
              <template v-slot:activator="{ on }">
                <v-btn
                  text
                  color="primary"
                  v-on="on">
                  <v-icon left>mdi-filter</v-icon>
                  Tip mesaje ({{logType}})
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="type in ['all', 'success', 'info', 'warning', 'error']"
                  :key="type"
                  @click="setLogType(type)">
                  <v-list-item-icon>
                    <v-icon :color="type === 'all' ? 'grey' : type">{{getIcon(type)}}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ type }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <v-menu
              :open-on-hover="false"
              :close-on-click="true"
              :close-on-content-click="true">
              <template v-slot:activator="{ on }">
                <v-btn
                  text
                  color="primary"
                  v-on="on">
                  <v-icon left>mdi-page</v-icon>
                  Mesaje pe pagina ({{logLimit}})
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="limit in [10, 20, 50, 100]"
                  :key="limit"
                  @click="setLogLimit(limit)">
                  <v-list-item-content>
                    <v-list-item-title>{{ limit }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <v-btn icon @click="clearLog">
              <v-icon color="error">
                mdi-delete-sweep
              </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon small>
              <v-icon color="red" @click="showLog = false">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="max-height: 75vh">
            <v-list dense>
              <v-list-item
                v-for="msg in logItems"
                :key="msg._id"
                two-line>
                <v-list-item-icon>
                  <v-icon :color="msg.type === 'all' ? 'grey' : msg.type">{{getIcon(msg.type)}}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ msg.text }}</v-list-item-title>
                  <v-list-item-subtitle>{{ (new Date(msg.createdAt)).toLocaleString('ro-RO') }} - {{ msg.user }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="deleteLogItem(msg._id)">
                    <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-pagination
              v-model="logPage"
              :length="logTotalPages"
              circle>
            </v-pagination>
          </v-card-actions>
        </v-card>
      </v-bottom-sheet>
    </v-main>
  </v-app>
</template>

<script>
import _debounce from 'lodash.debounce'
import SERVER_URL from '@/config'

export default {
  name: 'App',
  data: () => ({
    SERVER_URL,
    validForm: true,
    drawer: false,
    loginForm: false,
    email: null,
    password: null,
    showPass: false,
    required: [val => !!val || 'Campul nu poate fi gol!'],
    showLog: false
  }),

  computed: {
    user () {
      return this.$store.getters.user
    },
    logItems () {
      return this.$store.getters.logItems
    },
    logType () {
      return this.$store.getters.logType
    },
    logLimit () {
      return this.$store.getters.logLimit
    },
    logPage: {
      get () {
        return this.$store.getters.logPage
      },
      set (value) {
        this.$store.dispatch('setLogItemsPage', value)
      }
    },
    logTotalPages () {
      return this.$store.getters.logTotalPages
    },
    logSearch: {
      get () {
        return this.$store.getters.logSearch
      },
      set: _debounce(function (value) {
        this.$store.dispatch('setLogSearch', value)
      }, 500)
    },
    apl () {
      return this.$store.getters.currentAPL
    }
  },

  methods: {
    getIcon (type) {
      switch (type) {
        case 'all': return 'mdi-text-box'
        case 'success': return 'mdi-check'
        case 'info': return 'mdi-information-outline'
        case 'warning': return 'mdi-alert-circle-outline'
        case 'error': return 'mdi-close'
      }
    },
    setLogLimit (limit) {
      this.$store.dispatch('setLogItemsLimit', limit)
    },
    setLogType (type) {
      this.$store.dispatch('setLogItemsType', type)
    },
    showLogSheet () {
      this.showLog = true
    },
    showLoginForm () {
      this.loginForm = true
    },
    closeLoginForm () {
      this.loginForm = false
      this.$refs.form.reset()
    },
    login () {
      this.$refs.form.validate()
      if (this.validForm) {
        this.$store.dispatch('login', { email: this.email, password: this.password })
        this.closeLoginForm()
      }
    },
    logout () {
      this.$store.dispatch('logout')
      if (this.$route.name !== 'Home') this.$router.push({ name: 'Home' })
    },
    deleteLogItem (id) {
      this.$store.dispatch('deleteLogItem', id)
    },
    clearLog () {
      this.$store.dispatch('deleteLogItem', null)
    },

    async getAPL () {
      const apl = await this.$store.dispatch('getAPL', this.$route.params.id)
      this.apl = Object.freeze(apl)
    },
    getURL () {
      return this.SERVER_URL + this.apl.logo.url
    },

    dummy () {}
  },

  beforeMount () {
    this.$store.dispatch('login')
  }
}
</script>

<style lang="stylus">
  .gm-style-iw.gm-style-iw-c .gm-style-iw-d {
    overscroll-behavior: contain;
  }

  .v-pagination__item {
    outline: none !important;
  }

  .avz-fab {
    bottom: 0;
    right: 0 !important;
    position: fixed !important;
    margin: 0 16px 16px 0;
    z-index: 1;
  }

  th[role="columnheader"] {
    white-space: nowrap;
  }

  .table-cell-wrap {
    white-space: normal;
  }
  .table-cell-no-wrap {
    white-space: nowrap;
  }
</style>
